import { $Q } from './query-selector';

export function setSidebarMenuPosition() {
  try {
    const headerMenuRect = $Q('.js-header');
    const root_styles = document.querySelector(':root');
    const portraitMode = window.matchMedia("(orientation: portrait)");

    portraitMode.addEventListener("change", (e) => {
      setSidebarmenuSize();
    });

    function setSidebarmenuSize() {
      root_styles.style.setProperty('--header-h', window.innerHeight - headerMenuRect.offsetHeight+'px');
    }

    setSidebarmenuSize()

  } catch (error) {
    console.log(error);
  }
}
